export const ReportsGetters = {}
